<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifc-filter-param-date-range-input
      [fc]="form.get('timestamp')"
      [label]="'Date'"
      (rangeSelected)="dateSelected($event)"
      baseFilterItem
    ></ifc-filter-param-date-range-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Level</mat-label>
      <mat-select matInput formControlName="level" placeholder="Level">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of data.options.levelOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="form.get('timestamp').value === 'custom'">
      <ifc-datepicker [fc]="form.get('timestampStart')" [label]="'Date from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('timestampEnd')" [label]="'Date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Endpoint</mat-label>
      <mat-select matInput formControlName="endpoint" placeholder="Endpoint">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of data.options.endpointOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Hostname</mat-label>
      <mat-select matInput formControlName="hostName" placeholder="Hostname">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of data.options.hostnameOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterFullRowItem>
      <mat-label>Logger</mat-label>
      <mat-select matInput formControlName="logger" placeholder="Logger">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of data.options.loggerOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Correlation ID</mat-label>
      <input matInput name="correlationId" formControlName="correlationId" type="text" placeholder="Correlation ID" />
      <button
        type="button"
        *ngIf="form.controls.correlationId.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.correlationId.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>ID</mat-label>
      <input matInput name="id" formControlName="id" type="text" placeholder="ID" />
      <button
        type="button"
        *ngIf="form.controls.id.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.id.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Principal name</mat-label>
      <input matInput name="principalName" formControlName="principalName" type="text" placeholder="Principal name" />
      <button
        type="button"
        *ngIf="form.controls.principalName.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.principalName.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Principal ID</mat-label>
      <input matInput name="principalId" formControlName="principalId" type="text" placeholder="Principal ID" />
      <button
        type="button"
        *ngIf="form.controls.principalId.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.principalId.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ifc-account-loan-number-input [fc]="form.get('loan')" baseFilterItem></ifc-account-loan-number-input>
    <ifb-business-name-input [fc]="form.get('entity')" baseFilterItem></ifb-business-name-input>

    <ifb-customer-email-input
      label="Customer email"
      [fc]="form.get('customer')"
      baseFilterItem
    ></ifb-customer-email-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Error ID</mat-label>
      <input matInput name="errorId" formControlName="errorId" type="text" placeholder="Error ID" />
      <button
        type="button"
        *ngIf="form.controls.errorId.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.errorId.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
